import React from 'react';
import { Grid, Modal } from 'semantic-ui-react';

// Global Components
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import ErrorAlert from 'components/ErrorAlert';
import QueryStringButton from 'components/QueryStringButton';
import QueryStringModal from 'components/QueryStringModal';

// Child Components
import TimesheetSubmitModalButton from './components/TimesheetSubmitModalButton';

// Constants
const QUERY_STRING_PARAM = 'timesheetSubmitModal';

const TimesheetSubmitModal = (): React.ReactElement => (
    <QueryStringModal
        param={QUERY_STRING_PARAM}
        modalProps={{
            size: 'tiny'
        }}
    >
        <ErrorBoundary
            namespace="TimesheetSubmitModal"
            FallbackComponent={<ErrorBoundaryAlert />}
        >
            <Modal.Header>Submit Timesheet</Modal.Header>
            <Modal.Content>
                <ErrorAlert namespace="TIMESHEET_SUBMIT" />
                <Grid centered>
                    <Grid.Column mobile={16} tablet={8} computer={8}>
                        <QueryStringButton
                            params={{
                                [QUERY_STRING_PARAM]: undefined,
                                selectedTimesheet: undefined
                            }}
                            buttonProps={{
                                type: 'button',
                                fluid: true,
                                basic: true,
                                primary: true
                            }}
                        >
                            Cancel
                        </QueryStringButton>
                    </Grid.Column>
                    <Grid.Column mobile={16} tablet={8} computer={8}>
                        <TimesheetSubmitModalButton />
                    </Grid.Column>
                </Grid>
            </Modal.Content>
        </ErrorBoundary>
    </QueryStringModal>
);

export default TimesheetSubmitModal;
